<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <!-- ASIDE LEFT - CONTENT NAV -->

    <ContainerFlex>
      <template slot="aside-left">
        <AsideLeft class="hidden lg:block">
          <template slot="title"> Alle {{ title }} </template>
          <li v-for="brand in brands" :key="brand.id" class="transition">
            <nuxt-link :to="brand.url">
              {{ brand.title }}
            </nuxt-link>
          </li>
        </AsideLeft>
      </template>
      <template slot="main-content">
        <div class="bg-grey-lighter mb-6 py-4 px-4 text-white">
          <Paragraph>
            <h4>
              {{ title }}
            </h4>
            <h3 class="text-blue-darker">Alle {{ title }}</h3>
            <!-- eslint-disable-next-line -->
            <div class="text-blue-dark wysiwyg" v-html="content" />
          </Paragraph>
        </div>
        <div class="flex flex-wrap px-2 lg:px-0 lg:mx-0 -mx-0 lg:-mx-2 -my-3">
          <BrandCard
            v-for="(brand, index) in brands"
            :key="brand.id"
            :brand="brand"
            :large="index === 0"
            class="wow fadeIn"
          />
        </div>
      </template>
      <template slot="aside-right">
        <AsideRight :coworker="consulter" />
      </template>
    </ContainerFlex>

    <!-- MENU SERVICE -->
    <div class="bg-grey-light">
      <Container class="py-13">
        <MenuService class="-mx-2 wow fadeIn" />
      </Container>
    </div>
  </div>
</template>

<script>
import MenuMain from '~/components/menu/MenuMain'
import Container from '~/components/layoutelements/Container'
import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import AsideLeft from '~/components/layoutelements/AsideLeft'
import AsideRight from '~/components/layoutelements/AsideRight'
import Paragraph from '~/components/Paragraph'
import MenuService from '~/components/menu/MenuService'
import BrandCard from '~/components/cardtypes/BrandCard'
export default {
  components: {
    MenuMain,
    Container,
    ContainerFlex,
    AsideLeft,
    AsideRight,
    Paragraph,
    MenuService,
    BrandCard,
  },
  async asyncData({ route, $axios }) {
    const result = await $axios.$get('/marken')
    return result
  },

  data() {},
}
</script>
